import { authLoginAction } from '@/redux/actions';
import { call, put } from 'redux-saga/effects';
import { ActionType } from 'deox';

import { authLogin } from '@/services/api';
import { calculateAccessTokenTime, calculateRefreshTokenTime } from '@/utils/handle-authentication';
import { handleAPIError } from '@/utils/handle-api-error';
import { TUserInfo } from '@/services/api/auth/get-user-info';
import Helpers from '@/services/helpers';

// FUNCTION
interface IAuthLoginResponse {
  status: number;
  data: {
    access_token: string;
    refresh_token: string;
    refresh_token_time: number;
    user: TUserInfo;
  };
}

export function* authLoginSaga(action: ActionType<typeof authLoginAction.request>): Generator {
  const { materials, successCallback, failedCallback } = action.payload;

  try {
    const response = yield call(authLogin, materials);
    const authLoginResponse: IAuthLoginResponse = response as IAuthLoginResponse;
    if (authLoginResponse.status === 200) {
      const accessTokenExpiredTime = calculateAccessTokenTime(response);
      const refreshTokenExpiredTime = calculateRefreshTokenTime(response);
      Helpers.storeAccessToken(authLoginResponse.data.access_token, accessTokenExpiredTime);
      Helpers.storeRefreshToken(authLoginResponse.data.refresh_token, refreshTokenExpiredTime);
      Helpers.storeUserInfo(authLoginResponse.data.user as TUserInfo);
      yield put(authLoginAction.success(authLoginResponse));
    }
    successCallback?.(authLoginResponse);
  } catch (err) {
    yield put(authLoginAction.failure(err));
    failedCallback?.(err);
    handleAPIError(err, 'Error.loginEmailError');
  }
}
